'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dPresto$0024$0024anon$002410 from "./presto.-Presto$$anon$10.js";
import * as $j_presto$002etypes$0024$002dCompact$002dFeature$0024 from "./presto.types$-Compact-Feature$.js";
import * as $j_presto$002etypes$0024$002dFeature$002dCode$0024 from "./presto.types$-Feature-Code$.js";
var $p;
/** @constructor */
function $c_Lpresto_Presto$$anon$9() {
  this.bdp = null;
  this.bdh = null;
  this.bdi = false;
  this.bdq = null;
  this.bdr = false;
  this.bdu = null;
  this.bdn = null;
  this.bdo = false;
  this.bdj = null;
  this.bdk = false;
  this.bdl = null;
  this.bdm = false;
  this.bds = false;
  this.bdt = false;
  this.bdp = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bdu = "CompactFeature";
}
export { $c_Lpresto_Presto$$anon$9 as $c_Lpresto_Presto$$anon$9 };
$p = $c_Lpresto_Presto$$anon$9.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Presto$$anon$9;
/** @constructor */
function $h_Lpresto_Presto$$anon$9() {
}
export { $h_Lpresto_Presto$$anon$9 as $h_Lpresto_Presto$$anon$9 };
$h_Lpresto_Presto$$anon$9.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.bdp;
});
$p.M = (function() {
  if ((!this.bdi)) {
    this.bdh = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bdi = true;
  }
  return this.bdh;
});
$p.O = (function() {
  if ((!this.bdr)) {
    this.bdq = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bdr = true;
  }
  return this.bdq;
});
$p.D = (function() {
  return this.bdu;
});
$p.t = (function() {
  if ((!this.bdo)) {
    this.bdn = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("value", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bdo = true;
  }
  return this.bdn;
});
$p.N = (function() {
  if ((!this.bdk)) {
    this.bdj = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dFeature$002dCode$0024.$m_Lpresto_types$FeatureCode$().ae0(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().e1)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bdk = true;
  }
  return this.bdj;
});
$p.Q = (function() {
  if ((!this.bdm)) {
    this.bdl = new $j_presto$002e$002dPresto$0024$0024anon$002410.$c_Lpresto_Presto$$anon$10();
    this.bdm = true;
  }
  return this.bdl;
});
$p.v = (function() {
  if ((!this.bdt)) {
    this.bds = false;
    this.bdt = true;
  }
  return this.bds;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee70) => ((p) => \u03b4scrutinee70.adE(p)))($j_presto$002etypes$0024$002dCompact$002dFeature$0024.$m_Lpresto_types$CompactFeature$())));
});
var $d_Lpresto_Presto$$anon$9 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Presto$$anon$9, "presto.Presto$$anon$9", ({
  Ns: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_Presto$$anon$9 as $d_Lpresto_Presto$$anon$9 };
//# sourceMappingURL=presto.-Presto$$anon$9.js.map
